module.exports = __webpack_public_path__ + "media/components/assets/dabang_bottle_06-b899e660991b6f1298938f40e9822554.png";